import React from "react";
import {
    Dialog as MuiDialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    styled,
} from "@mui/material";
import { ReactComponent as Warning } from "assets/img/warningImage.svg";

const Dialog = styled(MuiDialog)(({ theme }) => ({
    "& .MuiDialog-container": {
        "& .MuiDialog-paper": {
            maxWidth: "780px",
            padding: "18px 25px",
        },
    },
}));

const LoginWarningModal = ({ open, onContinue, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection={"column"}
                    gap={1}
                    mb={1}
                >
                    <Warning width={70} height={70} />
                    <Typography
                        sx={{ fontSize: "26px", fontWeight: 700, color: "#0f172a" }}
                    >
                        You already have a Kardia account
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 4 }}>
                We noticed that you already have a Kardia account with us. Please login
                and upgrade your account with your existing credentials in order to
                proceed.
            </DialogContent>
            <DialogActions
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <Button
                    onClick={onContinue}
                    variant="contained"
                    sx={{
                        width: "50%",
                    }}
                >
                    Login to Kardia
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoginWarningModal;
